import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { BadgePlus, Check } from 'lucide-react';
import { cn } from '@fortem-monorepo/js-utilities';
import { Combobox, ComboboxChip, ComboboxChips, ComboboxChipsInput, ComboboxValue, } from '../../ui/combobox';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, } from '../../ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
export const MultiSelectCreate = ({ className, singularPhrase = 'Tag', pluralPhrase = 'Tags', items = [], value, onValueChange, onInteractOutside,
// ...props
 }) => {
    const [open, setOpen] = React.useState(false);
    const [inputValue, setInputValue] = React.useState('');
    const inputRef = React.useRef(null);
    const actualItems = React.useMemo(() => [...new Set([...items, ...(value ?? [])])], [items, value]);
    const filteredItems = React.useMemo(() => actualItems.filter((tag) => !value?.includes(tag)), [actualItems, value]);
    const handleAddTag = (tag) => {
        onValueChange?.([...(value ?? []), normalizeTag(tag)]);
        handleFocusInput();
    };
    const handleRemoveTag = (tag) => {
        const newValues = [...(value ?? [])].filter((val) => val !== tag);
        onValueChange?.(newValues);
        handleFocusInput();
    };
    const handleFocusInput = () => {
        setTimeout(() => inputRef.current?.focus());
    };
    const handleKeyDown = (e) => {
        if (!value?.length)
            return;
        if (e.key === 'Backspace' && inputValue === '') {
            if (!open) {
                setOpen(true);
                handleFocusInput();
            }
            const newValues = [...(value ?? [])];
            newValues.pop();
            onValueChange?.(newValues);
        }
    };
    const handleInputChange = (e) => {
        if (!open) {
            setOpen(true);
            handleFocusInput();
        }
        setInputValue(e.target.value);
    };
    const normalizeTag = (tag) => tag.trim();
    const hideCommand = (filteredItems.length === 0 && inputValue === '') || value?.includes(normalizeTag(inputValue));
    return (_jsx(Popover, { open: open, onOpenChange: (open) => {
            setOpen(open);
            if (open) {
                handleFocusInput();
            }
        }, children: _jsxs(Combobox, { multiple: true, value: value, children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx(ComboboxChips, { className: cn('w-full bg-white', className), onClick: (e) => {
                            if (open && document.activeElement === inputRef.current) {
                                e.preventDefault();
                            }
                        }, children: _jsx(ComboboxValue, { children: (values) => {
                                return (_jsxs(React.Fragment, { children: [values.map((value) => (_jsx(ComboboxChip, { value: value, onRemove: handleRemoveTag, className: '*:data-[slot=combobox-chip-remove]:h-auto!', children: value }, value))), _jsx(ComboboxChipsInput, { placeholder: 'Add ' + pluralPhrase?.toLocaleLowerCase(), onKeyDown: handleKeyDown, ref: inputRef, value: inputValue, onChange: handleInputChange })] }));
                            } }) }) }), _jsx(PopoverContent, { className: cn('p-0', {
                        'border-transparent': hideCommand,
                    }), align: "start", side: "bottom", onInteractOutside: onInteractOutside, children: _jsxs(Command, { className: cn({
                            hidden: hideCommand,
                        }), children: [_jsx(CommandInput, { value: inputValue, onValueChange: setInputValue, show: false }), !hideCommand && (_jsx(CommandEmpty, { className: 'p-1', children: _jsxs("div", { className: 'px-8 py-4 text-sm flex items-center justify-center gap-2 hover:bg-gray-100 transition-all cursor-pointer h-full select-none', onClick: () => {
                                        handleAddTag(inputValue);
                                        setInputValue('');
                                    }, children: [_jsx(BadgePlus, { size: 16, className: 'text-green-500' }), _jsxs("span", { className: 'max-w-[75%] truncate', children: ["Create ", singularPhrase?.toLocaleLowerCase(), ": ", normalizeTag(inputValue)] })] }) })), _jsx(CommandList, { children: _jsx(CommandGroup, { children: filteredItems.sort().map((item) => {
                                        const isSelected = value?.includes(item);
                                        return (_jsx(CommandItem, { disabled: isSelected, value: item, className: 'flex gap-2 justify-between', asChild: true, children: _jsxs("div", { onClick: () => {
                                                    handleAddTag(item);
                                                    setInputValue('');
                                                }, children: [item, isSelected && _jsx(Check, { className: cn('text-green-700 ml-auto h-4 w-4') })] }) }, item));
                                    }) }) })] }) })] }) }));
};
